import {ISetChartTypeAction} from './types/pdfReport.types';

export const SET_CHART_TYPE = 'SET_CHART_TYPE';

export const setChartTypeAction = (sequenceChartType: string): ISetChartTypeAction => ({
    type: SET_CHART_TYPE,
    payload: sequenceChartType,
});
